import { render, staticRenderFns } from "./UploadCV.vue?vue&type=template&id=36cd3d13"
import script from "./UploadCV.vue?vue&type=script&lang=ts"
export * from "./UploadCV.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports